import { useCallback, useState } from 'react'
import api from '@/lib/api'

export function useUtils() {
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const buscarCNPJ = useCallback(async (cnpj: string) => {
    setLoading(true)
    setError(null)
    try {
      const response = await api.get(`/utils/cnpj/${cnpj}`)
      return response.data
    } catch (err) {
      setError('Erro ao consultar informações do CNPJ no sistema.')
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  const buscarCEP = useCallback(async (cep: string) => {
    setLoading(true)
    setError(null)
    await new Promise(resolve => setTimeout(resolve, 1000))

    try {
      const response = await api.get(`/utils/cep/${cep}`)
      return response.data
    } catch (err: any) {
      // Usar "any" para garantir que podemos acessar err.message
      setError('Erro ao consultar informações do CEP no backend.')
      return null // Retorna null caso ocorra erro
    } finally {
      setLoading(false) // Sempre encerrar o carregamento
    }
  }, [])

  const gerarSelic = useCallback(async () => {
    setLoading(true)
    setError(null)

    try {
      const { data: selicDataRaw } = await api.get('/utils/selic')

      let selicArray: { data: string; valor: number }[] = []

      if (Array.isArray(selicDataRaw)) {
        // já é o formato correto
        selicArray = selicDataRaw as typeof selicArray
      } else if (Array.isArray(selicDataRaw?.data)) {
        selicArray = selicDataRaw.data
      } else if (selicDataRaw && typeof selicDataRaw === 'object') {
        selicArray = Object.entries(selicDataRaw).map(([key, value]) => ({
          data: key,
          valor: Number(value)
        }))
      }

      selicArray.sort((a, b) => (a.data < b.data ? 1 : -1))

      localStorage.setItem('selic', JSON.stringify(selicArray))

      return selicArray
    } catch (err: any) {
      setError('Erro ao consultar informações do Selic no backend.')
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  return { loading, error, buscarCNPJ, buscarCEP, gerarSelic }
}
